import Vue from 'vue'
import Vuex from 'vuex'
// import pkg from 'package'
import * as actions from './actions'
import * as getters from './getters'
// import merge from 'deepmerge'

// import app from './modules/app'
import menuBuilder from './modules/menu'
import userBuilder from './modules/user'
import styles from './modules/styles'
import appState from './modules/appState'
import clubSettingsBuilder from './modules/clubSettings'
import appConfigBuilder from './modules/appConfig'

var emptyUser

export function getEmptyUser () {
  return emptyUser.state
}

export default function (config) {

  Vue.use(Vuex)

  const menu = menuBuilder(config)
  const clubSettings = clubSettingsBuilder(config.clubSettings || [])
  const appConfig = appConfigBuilder(config.appConfig || [])
  const user = userBuilder(config.appUser || [])

  emptyUser = JSON.parse(JSON.stringify(user)) // Store a default copy of the user store, used for resetting the user store on logout.

  return new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    actions,
    getters,
    modules: {
      // app,
      menu,
      styles,
      appState,
      clubSettings,
      appConfig,
      user
    },
    /*
    state: {
      pkg
    },
    */
    mutations: {
    }
  })
}
